import { render, staticRenderFns } from "./xyf.vue?vue&type=template&id=557531b2&scoped=true"
import script from "./xyf.vue?vue&type=script&lang=js"
export * from "./xyf.vue?vue&type=script&lang=js"
import style0 from "./xyf.vue?vue&type=style&index=0&id=557531b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557531b2",
  null
  
)

export default component.exports